<template>
    <div class="manageroptions container-fluid p-0">
        <div class="row">
            <div id="selectedimages" v-if="mobile && selectedImagesLength > 0 || !mobile"
                :class="['col-12 col-md-4 d-flex justify-content-between justify-content-md-start align-items-center', mobile && 'py-2 py-md-0 ml-2']"
            >
                <div class="pl-md-3">
                    <b-form-checkbox
                        class="manageroptions-selection"
                        id="selectedImages"
                        name="selectedImages"
                        v-model="checkSelectedImages"
                        @change="selectedImagesLength === 0 ? $emit('selectAllImages') : $emit('removeImageSelection')"
                    >
                        <span v-if="selectedImagesLength === 1">
                            {{ selectedImagesLength }} mídia selecionada
                        </span>

                        <span v-else-if="selectedImagesLength > 1">
                            {{ selectedImagesLength }} mídias selecionadas
                        </span>

                        <span v-else>
                            Nenhuma mídia selecionada
                        </span>
                    </b-form-checkbox>
                </div>

                <button v-if="selectedImagesLength >= 1" class="btn-delete ml-md-3" @click="$emit('deleteSelectedImages')">
                    <i class="fal fa-trash-alt font-14" aria-hidden="true"></i>
                    <span class="font-sans fw-regular">Excluir</span>
                </button>
            </div>

            <!-- opcoes de visualizacao das galerias -->
            <div
                v-if="mobile && selectedImagesLength === 0 || !mobile"
                :class="['col-12 col-md-4 d-flex p-0 justify-content-between justify-content-md-end align-items-center', mobile && 'mx-2']"
            >
                <b-dropdown right class="" size="lg"  variant="link" toggle-class="text-decoration-none">
                    <template #button-content>
                        <i :class="iconDisplayActive" class="icon-display font-14" aria-hidden="true"></i>
                    </template>
                    <b-dropdown-item-button
                        class="text-right"
                        button-class="d-flex justify-content-between"
                        v-for="item in display"
                        :key="item.id"
                        @click="setActiveDisplay(item.id)"
                        :active="isDisplayActive(item)"
                    >
                        <span v-html="item.name"></span>
                        <i :class="item.icon" class="icon-display font-20" aria-hidden="true"></i>
                    </b-dropdown-item-button>
                </b-dropdown>

                <!-- filtros dos resultados das galerias -->
                <b-dropdown class="mx-3 manageroptions-filter" id="dropdown-buttons" :text="activeFilter.name">
                    <b-dropdown-item-button
                        v-for="filter in filters"
                        :key="filter.id"
                        @click="setActiveFilter(filter.id)"
                        :active="isFilterActive(filter)"
                        style="background-color: transparent; font-weight: 400;"
                    >
                        <span v-html="filter.name"></span>
                    </b-dropdown-item-button>
                </b-dropdown>
            </div>

            <!-- busca por nome galerias -->
            <search-input
                :id="'searchMedia'"
                :name="'searchMedia'"
                :onDebounce="filtersImages"
                @clearInputSearch="handleClearInputSearch"
                @inputValueChanged="searchImages = $event"
            />
        </div>
    </div>
</template>


<script>
import SearchInput from './SearchInput.vue';

export default {
    name: 'ImageManagerOptions',
    components: {
        SearchInput
    },
    data() {
        return {
            mobile: window.innerWidth < 576,
            checkSelectedImages: this.selectedImagesLength > 1 ? true : false,
            display: [
                {id: 0, name: 'Grande', value: 'icons', icon: 'fal fa-th-large'},
                {id: 1, name: 'Lista', value: 'list', icon: 'fal fa-bars'},
            ],
            filters: [
                {id: 0, name: 'Mais recentes', value: 'created_at-desc'},
                {id: 1, name: 'Mais antigos', value: 'created_at-asc'},
                {id: 2, name: 'Nome A-Z', value: 'name-asc'},
                {id: 3, name: 'Nome Z-A', value: 'name-desc'}
            ],
            activeFilter: {id: 0, name: 'Mais recentes', value: 'created_at-desc'},
            activeDisplay: {id: 0, name: 'Ícones Grandes', value: 'icons'},
            searchImages: '',
            iconDisplayActive: null
        }
    },
    props: {
        selectedImagesLength: {
            type: Number,
            required: true
        }
    },
    methods: {
        isFilterActive(filter) {
            if (filter.id === this.activeFilter.id) {
                return true;
            } else {
                return false;
            }
        },
        isDisplayActive(display) {
            if (display.id === this.activeDisplay.id) {
                this.iconDisplayActive = display.icon;
                return true;
            } else {
                return false;
            }
        },
        setActiveFilter(id) {
            this.activeFilter = this.filters.find(item => item.id === id);
            this.$emit('changeFilter', this.activeFilter.value);
        },
        setActiveDisplay(id) {
            this.activeDisplay = this.display.find(item => item.id === id);
            this.$emit('changeDisplay', this.activeDisplay.value);
        },
        filtersImages() {
			let token = this.$session.get("jwt");
			let siteId = this.$session.get("siteId");

			this.$store.dispatch("userModule/FILTERS_MEDIAS", [token, siteId, this.searchImages, this.activeFilter.value]);
		},
        handleClearInputSearch() {
            this.searchImages = '';

            this.filtersImages();
        }
    },
    watch: {
        checkSelectedImages(value) {
            if (!value) {
                this.$emit('removeSelectedImages');
            }
        },
        selectedImagesLength(value) {
            if (value === 0) {
                this.checkSelectedImages = false;
            } else {
                this.checkSelectedImages = true;
            }
        },
        searchImages(value) {
            if (value != '') {
                this.$emit('inSearch', true);
            } else {
                this.$emit('inSearch', false);
            }
        },
    }
}
</script>

<style>
    .fw-light {
        font-weight: 300;
    }
    .fw-regular {
        font-weight: 400!important;
    }
    .fw-bold {
        font-weight: 500;
    }
    .font-sans {
        font-family: 'Open Sans', sans-serif;
    }

    .manageroptions.container-fluid {
        position: fixed;
        top: 5rem !important;
        left: 0px;
        z-index: 601;
        background-color: white;
    }

    .manageroptions-selection span {
        color: var(--mediaManagerTheme)!important;
    }

    /* fundo dos botoes de dropdown */
    .manageroptions .dropdown-item.active, .manageroptions .dropdown-item:active {
        background-color: var(--main-color)!important;
    }

    .manageroptions .dropdown-item.active span, .manageroptions .dropdown-item:active span,
    .manageroptions .dropdown-item.active i, .manageroptions .dropdown-item:active i {
        color: #ffffff!important;
    }
    .manageroptions .btn.dropdown-toggle.btn-link {
        color: var(--mediaManagerTheme)!important;
    }

    .manageroptions .btn.dropdown-toggle:hover i , .manageroptions .btn.dropdown-toggle:hover {
        color: #000000!important;
    }

    .btn-delete {
        color: var(--mediaManagerTheme);
        border: none;
        background-color: transparent;
        padding-right: 0.75rem;
    }

    .btn-delete span, .icon-display {
        font-weight: 700;
        color: var(--mediaManagerTheme);
    }

    #dropdown-buttons {
        width: 200px;
    }

    .manageroptions-filter > button {
        background-color: transparent!important;
        color: var(--mediaManagerTheme)!important;
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
    }

    .manageroptions-filter > button:hover {
        color: #000000!important;
    }

    @media screen and (max-width: 576px) {
        .manageroptions #selectedimages {
            height: 58px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/atoms/ImageManagerOptions.vue